import { CommentThread } from 'src/components/conversation/src/components/comment-tree';
import store from 'src/utils/store';

export const getDiffHashes = (path: string): string[] => {
  const regex = new RegExp(`/diff/([a-fA-F0-9]+)\\.\\.([a-fA-F0-9]+)/?$`);
  const match = regex.exec(path);
  // if matched, the first element in the array is the input string. We slice past that since we don't need it.
  return match ? match.slice(1) : ['', ''];
};

/**
 *
 * @param conversations
 * @param src_rev
 * @param dest_rev
 * @param base_rev
 * @returns CommentThread[]
 *
 * Filters comment theads and returns those that should be rendered in the context of the current diff (ex: all changes, custom diff)
 * If a custom diff is specified, we filter by the current diff src_rev and dest_rev
 * If looking at All Changes, we filter for all conversations with null base_revs, meaning those previously created on the all changes diff
 */
export const filterCodeReviewThreads = (
  commentThreads: CommentThread[],
  src_rev?: string,
  dest_rev?: string,
  base_rev?: string
): CommentThread[] => {
  // All Changes diff scenario
  if (base_rev === undefined) {
    return commentThreads.filter(thread => !thread.topComment.inline?.base_rev);
  }

  // Custom diff scenario
  return commentThreads.filter(thread => {
    return (
      src_rev === thread.topComment.inline?.src_rev &&
      dest_rev === thread.topComment.inline?.dest_rev
    );
  });
};

type StorageSettings = {
  width: number;
  isSidebarCollapsed: boolean;
};

const DIFF_TAB_SIDEBAR_PREFS_STORAGE_KEY = 'diff.tab.sidebar.prefs';

export const getDiffSidebarPrefs = (): StorageSettings => {
  return store.get(DIFF_TAB_SIDEBAR_PREFS_STORAGE_KEY);
};

export const saveDiffSidebarPrefs = (
  width: number,
  isSidebarCollapsed: boolean
): void => {
  store.setStrictlyNecessaryItem(DIFF_TAB_SIDEBAR_PREFS_STORAGE_KEY, {
    width,
    isSidebarCollapsed,
  });
};
